<div class="profile-page">
  <!-- ── Page header (matches other pages) ────────────────────────────── -->
  <header class="profile-header">
    <h1 class="profile-header__title" data-testid="user-profile-title">
      {{ T.userProfile.pageTitle }}
    </h1>
  </header>

  <!-- ── Single profile card (dashboard-style) ────────────────────────── -->
  <section class="profile-card">
    <!-- Centered identity badge -->
    <div class="identity">
      <div class="identity__avatar" aria-hidden="true">
        <span class="identity__initials">{{ initials() }}</span>
        <span class="identity__ring"></span>
      </div>

      <h2 class="identity__name" data-testid="user-profile-name">
        {{ auth.userName() || auth.userEmail() }}
      </h2>

      @if (auth.userName() && auth.userEmail()) {
        <p class="identity__email" data-testid="user-profile-email">
          {{ auth.userEmail() }}
        </p>
      }

      @if (roles().length || businessEntities().length) {
        <div class="identity__chips" data-testid="user-profile-chips">
          @for (role of roles(); track role) {
            <span
              class="chip chip--role"
              [attr.data-testid]="'user-profile-role-chip-' + role"
            >
              <Symbol name="shield_person" class="chip__icon"></Symbol>
              {{ role }}
            </span>
          }
          @for (entity of businessEntities(); track entity) {
            <span
              class="chip chip--entity"
              [attr.data-testid]="'user-profile-entity-chip-' + entity"
            >
              <Symbol name="domain" class="chip__icon"></Symbol>
              {{ entity }}
            </span>
          }
        </div>
      }
    </div>

    <div class="profile-card__divider" aria-hidden="true"></div>

    <!-- Details list -->
    <ul class="details-list">
      <li class="details-row">
        <div class="details-row__icon">
          <Symbol name="person"></Symbol>
        </div>
        <div class="details-row__meta">
          <span class="details-row__label">{{
            T.userProfile.fields.name
          }}</span>
          <span
            class="details-row__value"
            data-testid="user-profile-detail-name-value"
            >{{ auth.userName() || '—' }}</span
          >
        </div>
      </li>

      <li class="details-row">
        <div class="details-row__icon">
          <Symbol name="alternate_email"></Symbol>
        </div>
        <div class="details-row__meta">
          <span class="details-row__label">{{
            T.userProfile.fields.email
          }}</span>
          <span
            class="details-row__value"
            data-testid="user-profile-detail-email-value"
            >{{ auth.userEmail() || '—' }}</span
          >
        </div>
      </li>
    </ul>
  </section>

  <!-- ── Preferences: default DCC ─────────────────────────────────────── -->
  <section
    class="profile-card prefs-card"
    data-testid="user-profile-preferences"
  >
    <div class="prefs">
      <p class="prefs__eyebrow">{{ T.userProfile.preferences.eyebrow }}</p>
      <h2 class="prefs__title">{{ T.userProfile.preferences.title }}</h2>
      <p class="prefs__subtitle">{{ T.userProfile.preferences.subtitle }}</p>

      @if (dccs().length) {
        <div class="prefs__field">
          <label class="prefs__label" for="default-dcc">{{
            T.userProfile.preferences.dccLabel
          }}</label>
          <select
            #dccSelect
            id="default-dcc"
            class="prefs__select"
            [value]="selectedDcc() ?? ''"
            (change)="onSelectDcc(dccSelect.value)"
            data-testid="user-profile-dcc-select"
          >
            <option value="" disabled [selected]="!selectedDcc()" hidden>
              {{ T.userProfile.preferences.dccPlaceholder }}
            </option>
            @for (dcc of dccs(); track dcc.dcc_code) {
              <option
                [value]="dcc.dcc_code"
                [selected]="dcc.dcc_code === selectedDcc()"
                [attr.data-testid]="'user-profile-dcc-option-' + dcc.dcc_code"
              >
                {{ dcc.name || dcc.dcc_code }}
              </option>
            }
          </select>
        </div>

        <div class="prefs__actions">
          <button
            type="button"
            class="prefs__save"
            [disabled]="!selectedDcc() || saving()"
            (click)="onSavePreferences()"
            data-testid="user-profile-save-preferences"
          >
            {{
              saving()
                ? T.userProfile.preferences.saving
                : T.userProfile.preferences.save
            }}
          </button>
        </div>
      } @else {
        <p class="prefs__empty" data-testid="user-profile-no-dccs">
          {{ T.userProfile.preferences.noDccs }}
        </p>
      }
    </div>
  </section>
</div>
